import { SCOrderListSortModifierType } from "@sellar-io/api-v2/types";
import { SortType } from "../../../lists/types";

export type SellarCreditOrderSortType =
  | "orderId_asc"
  | "orderId_desc"
  | "business_asc"
  | "business_desc";

export const SellarCreditOrderSortValues: SortType<
  SCOrderListSortModifierType,
  SellarCreditOrderSortType
> = {
  orderId_asc: {
    key: "orderId_asc",
    name: "Order first",
    mutation: {
      type: "id",
      direction: "asc",
    },
  },
  orderId_desc: {
    key: "orderId_desc",
    name: "Order latest",
    mutation: {
      type: "id",
      direction: "desc",
    },
  },
  business_asc: {
    key: "business_asc",
    name: "Business name (A-Z)",
    mutation: {
      type: "businessName",
      direction: "asc",
    },
  },
  business_desc: {
    key: "business_desc",
    name: "Business name (Z-A)",
    mutation: {
      type: "businessName",
      direction: "desc",
    },
  },
};
